import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the LoadpredefinedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-loadpredefined',
  templateUrl: 'loadpredefined.html',
})
export class LoadpredefinedPage {

  Data = []
  _selectedRouteId = 0
  _title = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad LoadpredefinedPage');
    this.loadData()
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }

  loadData() {
    this._title = this.navParams.get('onlyloc') == true ? this.dic.l["downloadLocations"] : this.dic.l["Takeorder"]


    var _that = this
    this.gn._Post('/api/gn/getpredefinetroutes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {

      // _that.Data = _data
      for (var i = 0; i < _data.length; i++) {
        if (_data[i].cnt >= 2) {
          _data[i].visible = true
          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].time = _that.formatSec(parseInt(_data[i].totaltime))
          _that.Data.push(_data[i])
        }

      }
    })
  }

  loadPredefined() {
    var cb = this.navParams.get('cb')
    cb(this._selectedRouteId)
    this.navCtrl.pop()
  }


  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }    
    const val = ev.target.value.toLowerCase()
    for (var i = 0; i < this.Data.length; i++) {
      if (val == '') {
        this.Data[i].visible = true
      } else {
        var itm = this.Data[i].name.toLowerCase()
        //if (itm.indexOf(val) > -1) {
        if (this.gn._latcyr(itm).indexOf(val) > -1 || this.gn._cyrlat(itm).indexOf(val) > -1) {
          this.Data[i].visible = true
        } else {
          this.Data[i].visible = false
        }
      }

    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/loadpredefined/loadpredefined.ts